








































import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'SettingMessage'
})
export default class extends Vue {
  isMessage = true
  isSystem = true
  isTodo = true
}
